import { render, staticRenderFns } from "./no-account.vue?vue&type=template&id=dc9dab86&scoped=true&"
import script from "./no-account.vue?vue&type=script&lang=js&"
export * from "./no-account.vue?vue&type=script&lang=js&"
import style0 from "./no-account.vue?vue&type=style&index=0&id=dc9dab86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9dab86",
  null
  
)

export default component.exports